/* eslint-disable no-unused-vars */
export enum EngagerSizes {
  LARGE = 'large',
  SMALL = 'small',
}
